module.exports = __webpack_public_path__ + "static/self_Employed-16cffb9f757518db3d05d71259cde111.svg";